/**
 * `rawMessage` is an AWSJSON scalar: it reaches the client as a JSON string.
 * Parse it once: an object is the OEM payload, a string is stored text that
 * was not valid JSON (shown verbatim in the Raw JSON view), null is "no
 * payload". An already-parsed value is kept as is.
 */
export const normalizeRawMessage = (value) => {
	if (value === null || value === undefined) return null;
	if (typeof value !== 'string') return value;
	try {
		const parsed = JSON.parse(value);
		return parsed === undefined ? null : parsed;
	} catch (error) {
		return value;
	}
};
